import { loadDocsComponentImport } from '@src/js/common/ark-extensions/dc-components/docs-component-import';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { FileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { Feature } from '@tencent/workbench';

@Feature()
export class AddRevisionFeature {
    public shouldHide() {
        const clientVar = SlideDataServices.ClientVarsService()?.getClientVars();
        return !(appConfigInstance.getConfig(FileMenuConfig.addRevision as any)
            && clientVar?.privilegeAttribute?.can_add_revision);
    }

    public async clickAddRevision() {
        const clientVarService = await SlideDataServices.ClientVarsService.promise();

        const dcImport = await loadDocsComponentImport();
        dcImport.importReplaceOneFile({
            padType: 'slide',
            fileId: clientVarService.getClientVars().padId ?? '',
        });
    }
}
